<div class="row basic-component" id="divProductInformation">
    <div class="col-sm-12">
        <form #testForm [formGroup]="frmProductInformation" name="frmProductInformation" novalidate #createForm="ngForm" role="form">
            <div class="row">
                <div class="col-sm-12 section-title" tabindex="0">
                    Product Information {{titleText}}
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 no-padding">
                    <table class="table table-inline product-info-table table-bordered">
                      <tbody>
                        <tr>
                          <td *ngIf="isPart">
                            <label id="drpRouteAdmin-label" aria-label="Route of Administration" class="form-label-control">Route of Administration</label>
                          </td>
                          <td class="label-text" *ngIf="isPart">
                            <ejs-multiselect #routeAdmins [dataSource]='routeAdminLOV'
                                             formControlName="drpRouteAdmin" aria-labelledby="drpRouteAdmin-label"
                                             [fields]='ddwFields' [placeholder]='RouteAdminWaterMark'
                                             [popupHeight]='ddwHeight' (change)='ddwChanged($event)'>
                            </ejs-multiselect>
                          </td>
                          <td *ngIf="!isPart">
                            <label id="drpProductTypes-label" aria-label="Product Type" class="form-label-control">Product Type</label>
                          </td>
                          <td *ngIf="!isPart">
                            <ejs-dropdownlist #productType [dataSource]='productTypesLOV' aria-labelledby="drpProductTypes-label"
                                              [value]="selectedProductTypes" [fields]='ddwFields'
                                              [placeholder]='prodTypesWaterMark' [popupHeight]='ddwHeight'
                                              formControlName="drpProductTypes" (change)='ddwChanged($event)'>
                            </ejs-dropdownlist>
                          </td>
                          <td>
                            <label class="form-label-control">NDC Product Code</label>
                          </td>
                          <td>
                            <div class="row">
                              <div class="col-sm-12 text-start">
                                <div class="row">
                                  <div class="col-sm-2">
                                    <div class="label-text text-start no-padding">
                                      NDC:
                                    </div>
                                  </div>
                                  <div class="col-sm-3">
                                    <div class="label-text">
                                      <label class="label-directive text-end">{{labelerCode}}</label>
                                    </div>
                                  </div>
                                  <div class="col-sm-1">
                                    <div class="text-center">
                                      <label class="label-text">&#8212;</label>
                                    </div>
                                  </div>
                                  <div class="col-sm-6">
                                    <input type="text" [attr.aria-label]="'NDC Product Code preceded by, ' + labelerCode + ' dash.'" formControlName="itemCode" class="form-control text-center mb-3" (blur)="ndcProductCodeChanged($event)" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                          <!-- <td *ngIf="!isPart" colspan="2"></td> -->
                        </tr>
                        <tr>
                          <td>
                            <label class="form-label-control">Source NDC</label>
                          </td>
                          <td>
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="row">
                                  <div class="col-sm-1 label-text">
                                    NDC:
                                  </div>
                                  <div class="col-sm-3">
                                    <input type="text" aria-label="First part of the source NDC code" formControlName="srcNDC1" class="form-control text-center" />
                                  </div>

                                  <div class="col-sm-1 no-padding text-center">
                                    <label class="label-text">&#8212;</label>
                                  </div>

                                  <div class="col-sm-3">
                                    <input type="text" aria-label="second part of the source NDC code" formControlName="srcNDC2" class="form-control text-center mb-3" />
                                  </div>
                                  <div class="col-sm-4">
                                    &nbsp;
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <label id="drpDeaSchedule-label" aria-label="DEA Schedule" class="form-label-control">DEA Schedule</label>
                          </td>
                          <td>
                            <ejs-dropdownlist #deaSchedules [dataSource]='deaScheduleLOV'
                                              [fields]='ddwFields' aria-labelledby="drpDeaSchedule-label"
                                              [placeholder]='deaScheduleWaterMark' [popupHeight]='ddwHeight'
                                              formControlName="drpDeaSchedule" (change)='ddwChanged($event)'>
                            </ejs-dropdownlist>
                          </td>
                        </tr>
                        <tr>
                          <td *ngIf="!bIsKit && !isPart">
                            <label id="drpRouteAdmin-label" aria-label="Route of Administration" class="form-label-control">Route of Administration</label>
                          </td>
                          <td *ngIf="!bIsKit && !isPart">
                            <ejs-multiselect #routeAdmins [dataSource]='routeAdminLOV'
                                             formControlName="drpRouteAdmin" for="drpRouteAdmin-label"
                                             [fields]='ddwFields' [placeholder]='RouteAdminWaterMark'
                                             [popupHeight]='ddwHeight' (change)='ddwChanged($event)'>
                            </ejs-multiselect>
                          </td>
                          <td *ngIf="false" colspan="2">
                            <input formControlName="hiddenProductType" class="form-control" />
                          </td>
                          <td *ngIf="canDisplayCertificationStatus" tabindex="0">
                            <label class="form-label-control">FDA Certification Status: {{dataProductDetail.listingRecordCertifiedThroughStatus || 'Not Found'}}</label>
                          </td>
                          <td *ngIf="canDisplayCertificationStatus" tabindex="0">
                            <label class="form-label-control">FDA Certification Date: {{dataProductDetail.listingRecordCertifiedThroughDate | dateToLocale }}</label>
                          </td>
                        </tr>
                        <tr *ngFor="let inactiveROAs of inactiveROAsList;" class="row">
                          <td colspan="3">
                            <app-warning-icon #warningContact [name]="inactiveROAs" [bIsCheckForLOVEntry]="true"></app-warning-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </div>
            </div>
    </form>
</div>
</div>

<ejs-dialog #confirmDialog [isModal]='isModal' [buttons]='confirmDlgButtons' [visible]='hidden'
    [position]='position' [animationSettings]='animationSettings' [width]='modalWidth'>
    <ng-template #content>
      <div class="card">
        <div class="card-header bg-primary">
            <h3 class="card-title text-white" tabindex="0">NDC Code Update</h3>
        </div>
        <div class="card-body" tabindex="0">
          Current Ndc Product code value will be updated with the new Ndc Product code value in the following areas:
          <ul>
            <li>NDC Product Code</li>
            <li>NDC Packaging Code</li>
            <li>NDC Product Code to establishment link</li>
          </ul>
        </div>
      </div>
    </ng-template>
</ejs-dialog>
